import { render, staticRenderFns } from "./MpCrossword2V2.vue?vue&type=template&id=696bf61c&scoped=true&"
import script from "./MpCrossword2V2.vue?vue&type=script&lang=js&"
export * from "./MpCrossword2V2.vue?vue&type=script&lang=js&"
import style0 from "./MpCrossword2V2.vue?vue&type=style&index=0&id=696bf61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bf61c",
  null
  
)

export default component.exports